import * as React from 'react';

function SvgBell(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 19.98 23.98" focusable={false} role="presentation" aria-hidden={true} {...props}>
      <path d="M19.63 18.05s-2.14-2.34-2.16-8a7.58 7.58 0 00-5-7.12V2.5a2.5 2.5 0 10-5 0v.43a7.54 7.54 0 00-5 7.12c0 5.63-2.14 8-2.15 8a1.28 1.28 0 00-.23 1.37 1.26 1.26 0 001.16.78h3.93a5 5 0 009.63 0h3.93a1.24 1.24 0 001.14-.77 1.35 1.35 0 00-.25-1.38zm-9.64-13a5 5 0 015 5 24.3 24.3 0 00.15 2.54H4.88a24.45 24.45 0 00.11-2.51 5 5 0 015-5.03zm0 16.41a2.5 2.5 0 01-2.15-1.26h4.31a2.49 2.49 0 01-2.16 1.26zm-6.47-3.79a15.16 15.16 0 001.17-3.78h10.62a15.16 15.16 0 001.17 3.78z" />
    </svg>
  );
}

const MemoSvgBell = React.memo(SvgBell);
export default MemoSvgBell;
